<!--
  前提情報ページ用の小さいアイデア投稿コンポーネント（PC用）
-->

<template>
  <v-main class="pa-0 smallideapost">
    <v-card outlined color="#F5F5F5" height="146px">
      <v-card-actions
        class="d-flex flex-column overflow-y-visible py-0"
      >
        <v-container class="ml-0">
          <v-row>
            <v-col cols="8" class="px-0 py-0">
              {{ aboutLid.ideaTheme || `${$t('アイデア')}投稿` }}
              <v-textarea
                color="#707070"
                :placeholder="`${aboutLid.ideaHolder || 'あなたはどう考える？'}（${ideaContentLength}文字以内）`"
                class="px-2 mx-0 rounded-xl py-0"
                rows="2"
                :rules="idearule"
                v-model="content"
                v-on:keydown.enter.ctrl.exact="submit()"
                counter
                no-resize
                style="border-style: ridge; border-width: 2px"
              ></v-textarea
            ></v-col>
            <v-col cols="4" class="py-0">
              <v-switch
                v-if="anonymousbtn"
                v-model="anonymous"
                label="匿名で投稿"
                class="w-auto my-0"
                :value="anonymous"
                hide-details="false"
              />
              <v-btn
                class="text-h6 font-weight-bold white--text"
                color="#008CFF"
                rounded
                x-large
                height="50"
                width="80"
                depressed
                @click="submit()"
                :disabled="!isSubmittable"
              >
                投稿
              </v-btn>
              <transition appear>
                <p v-if="showPostedMessage">{{$t('アイデア')}}ページに<br/>投稿されました</p>
              </transition>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <!--componets-->
    <activity_function ref="activityfunc" />
  </v-main>
</template>
<script>
import activity_function from "../profile/activity_function.vue";
import firebase from "firebase";
export default {
  name: "smallideapost",
  props: ["lidId", "pageType"],
  components: {
    activity_function,
  },
  data(vm) {
    return {
      showPostedMessage: false,
      submitting: false,
      createIdeaPage: vm.createIdeaInject,
      createdIdeaPage: vm.createdIdeaInject,
      editIdeaPage: vm.editIdeaInject,
      reportProblemIdea: vm.reportProblemIdea,
      detailIdeaPage: vm.detailIdeaPage,
      deleteIdeaAlert: vm.deleteIdeaInject,
      createIdeaPageDetail: vm.createIdeaPageDetail,
      ideauid: null,
      ideauids: [],
      aideauids: [],
      ideaContentLength: Number(
        process.env.VUE_APP_VALUE_IDEA_CONTENT_LENGTH || "110"
      ),
      idearule: [
        (v) =>
          v.length <=
            Number(process.env.VUE_APP_VALUE_IDEA_CONTENT_LENGTH || "110") ||
          `[エラー]入力は${Number(
            process.env.VUE_APP_VALUE_IDEA_CONTENT_LENGTH || "110"
          )}文字までです`,
      ],
      db: null, // created で初期化
      f: vm.contentInject, // アイデアを入力した時に v-model でデータを保存
      content: vm.contentInject, // アイデアを入力した時に v-model でデータを保存
      placename: vm.placenameInject,
      supplement: vm.supplementInject,
      links: [],
      idea: [], // 全件取得した時に全件分のデータを入れる
      num: 0,
      todayy: null,
      timeday: null,
      timehour: null,
      ideaImage: "",
      ideaImage_large: "",
      ideaSize: 4,
      likeList: [],
      liked: {},
      postcolor: "",
      titleRules: [(v) => v.length <= 20 || "20文字以内で入力してください"],
      anonymous: false,
      LidSankaAlert: false,
      images: false,
      ideadata: false,
      idealist: true,
      sortc: false,
      serchc: false,
      keyword: "",
      dialog_image: "",
      hoge: "",
      uidlist: [],
      showedIdea: [],
      limits: 50,
      tag: "",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      ideaplace: false,
      mapViewOn: false,
      data_location_lat: Number(
        process.env.VUE_APP_LOCATION_LAT || 35.6813320349034
      ),
      data_location_lng: Number(
        process.env.VUE_APP_LOCATION_LNG || 139.76716771167693
      ),
      latlngInput: { lat: 0, lng: 0 },
      markers: {
        lat: 0,
        lng: 0,
      },
      dataAnalyzeOn: false,
      dataAnalyzeOnNetwork: false,
      negaPosiOn: false,
      words_list: [],
      word_dict: {},
      nega_posi_all: {},
      edge_dict: {},
      result_print: false,
      ideaFontSize: "18px",
      quotingId: "",
      quotingContent: {},
      detailIdeaContent: {},
      quotingName: "",
      author: "",
      fab: false,
      isQuoting: false,
      authModal: false,
      profImageDict: {},
      profile: false,
      profileUid: "",
      govRead: process.env.VUE_APP_FEATURE_GOV_READ === "1",
      idea_loadLimit: false,
      setallidea: true,
    };
  },
  inject: {
    createIdeaInject: { default: false },
    editIdeaInject: { default: false },
    deleteIdeaInject: { default: false },
    contentInject: { default: "" },
    placenameInject: { default: "" },
    supplementInject: { default: "" },
    linkInject: { default: "" },
    firstIdea1Inject: { default: false },
    firstIdea2Inject: { default: false },
    createIdeaPageDetail: { default: false },
    createdIdeaPage: { default: false },
  },
  created() {
    this.db = firebase.firestore(); // dbインスタンスを初期化
    this.today();
  },
  computed: {
    uid() {
      return this.$store.state.auth?.user?.uid || "";
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    currentName() {
      return this.$store.state.auth.user.displayName;
    },
    lid() {
      return this.$store.state.lid;
    },
    alid() {
      return this.$store.state.alid;
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
    isSubmittable() {
      return (
        this.isAuthed &&
        this.content.length >= 1 &&
        this.content.length <= this.ideaContentLength /*&&
        (!this.aboutLid.tags || !this.aboutLid.tags.required || this.tag)*/
      );
    },
  },
  methods: {
    //idea登録
    submit() {
      this.submitting = true;
      if (!this.isSubmittable) {
        return;
      }
      try {
        const feedbackLidId = process.env.VUE_APP_FEEDBACK_LID_ID || "";
        if (feedbackLidId?.split(",").includes(this.lidId)) {
          const gasUrl = process.env.VUE_APP_FEEDBACK_GAS_URL || "";
          if (gasUrl) {
            fetch(
              `${gasUrl}?uid=${this.uid}&name=${this.currentName}&message=${this.content}&url=${window.location.href}`
            );
          }
        }
      } catch (e) {
        console.error(e);
      }
      this.createIdeaPage = false;
      this.createdIdeaPage = true;
      let self = this;
      this.today();
      let now = new Date().toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
      //console.log("this.latlngInput.lat = ",this.latlngInput.lat)
      //console.log("this.latlngInput.lng = ",this.latlngInput.lng)
      if (!this.latlngInput.lat) {
        this.latlngInput.lat = 0;
        this.latlngInput.lng = 0;
        this.markers.lat = 0;
        this.markers.lng = 0;
      }
      if (!this.anonymous) {
        let collection = this.db
          .collection("0")
          .doc(this.lidId)
          .collection("idea");
        collection
          .add({
            isActive: true,
            isHidden: false,
            content: this.content,
            placename: this.placename,
            supplement: this.supplement,
            links: this.linksParser(this.links),
            author: this.uid,
            createdAt: now, //firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: null,
            sort: this.todayy,
            inspires: null,
            timeday: this.timeday,
            timehour: this.timehour,
            like: [],
            edit: false,
            ideaImage: this.ideaImage,
            ideaImage_large: this.ideaImage_large,
            postcolor: this.postcolor,
            anonymous: this.anonymous,
            quotingId: this.quotingId,
            tag: {
              title: this.tag || "",
              color: this.postcolor,
            },
            latlngInputLat: this.latlngInput.lat,
            latlngInputLng: this.latlngInput.lng,
          })
          .then(function (docRef) {
            // 保存に成功した時
            //console.log("Document written with ID: ", docRef.id);
            self.$refs.activityfunc.ideapost(
              self.lidId,
              docRef.id,
              self.content
            );
            //console.log(self.$route.params.id, docRef.id, self.content);
          })
          .catch(function (error) {
            // 保存に失敗した時
            //alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。なお、投稿できる写真のサイズは1MBまでです。")
            console.error("Error adding document:", error);
          });
      } else {
        let collection = this.db
          .collection("0")
          .doc(this.lidId)
          .collection("idea");
        collection
          .add({
            isActive: true,
            isHidden: false,
            content: this.content,
            placename: this.placename,
            supplement: this.supplement,
            links: this.linksParser(this.links),
            author: "XXXXX",
            createdAt: now, //firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: null,
            sort: this.todayy,
            inspires: null,
            timeday: this.timeday,
            timehour: this.timehour,
            like: [],
            edit: false,
            ideaImage: this.ideaImage,
            ideaImage_large: this.ideaImage_large,
            postcolor: this.postcolor,
            anonymous: this.anonymous,
            quotingId: this.quotingId,
            tag: {
              title: this.tag || "",
              color: this.postcolor,
            },
            latlngInputLat: this.latlngInput.lat,
            latlngInputLng: this.latlngInput.lng,
          })
          .then(function (docRef) {
            // 保存に成功した時
            //console.log("Document written with ID: ", docRef.id);
            self.db
              .collection("0")
              .doc(self.lidId)
              .collection("aidea")
              .doc(docRef.id)
              .set({
                id: docRef.id,
                author: self.uid,
                currentName: self.currentName,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                content: self.content,
              });
            const aideas = self.db
              .collection("0")
              .doc(self.lidId)
              .collection("liduser")
              .doc(self.uid)
              .collection("aidea")
              .doc("aideas");
            aideas.set(
              {
                aideas: firebase.firestore.FieldValue.arrayUnion(docRef.id),
              },
              { merge: true }
            );
            self.aideauids.push(docRef.id);
          })
          .catch(function (error) {
            // 保存に失敗した時
            //alert("エラーが発生しました。恐れ入りますがもう一度操作をやり直してみてください。なお、投稿できる写真のサイズは1MBまでです。")
            console.error("Error adding document:", error);
          });
      }
      this.clearIdeaTempData();
    },
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num;
    },
    today() {
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1);
      let dd = this.toDoubleDigits(date.getDate());
      let hh = this.toDoubleDigits(date.getHours());
      let mi = this.toDoubleDigits(date.getMinutes());
      let se = this.toDoubleDigits(date.getSeconds());
      let ms = this.toDoubleDigits(date.getMilliseconds());
      this.todayy = yyyy + mm + dd + hh + mi + se + ms;
      this.timeday = mm + "/" + dd;
      this.timehour = hh + ":" + mi;
    },
    clearIdeaTempData() {
      // アイデア送信後・アイデア編集後・または投稿キャンセル時に呼び出す
      this.createIdeaPage = false;
      this.editIdeaPage = false;
      this.content = "";
      this.postcolor = "";
      this.isQuoting = false;
      this.quotingId = "";
      this.quotingContent = {};
      this.quotingName = "";
      this.placename = "";
      this.supplement = "";
      this.links.splice(0, this.links.length);
      this.tag = "";
      this.detailIdeaContent = {};
      this.detailIdeaPage = false;
      this.author = "";
      this.ideaImage = null;
      this.ideaImage_large = null;
      this.latlngInput.lat = 0;
      this.latlngInput.lng = 0;
      this.markers.lat = 0;
      this.markers.lng = 0;
      this.submitting = false;
      // showPostedMessageをtrueにし、3秒後にfalseにする
      this.showPostedMessage = true;
      setTimeout(() => {
        this.showPostedMessage = false;
      }, 3000);
    },
    linksParser(links) {
      // linkのurlが存在し、かつ安全かどうかをチェック
      return (
        links
          .map((link) => {
            return {
              ...link,
              url:
                link.url && /^https?:/.test(link.url)
                  ? link.url
                  : `https://${link.url}`,
            };
          })
          .filter((link) => /^https?:/.test(new URL(link.url).protocol)) || []
      );
    },
  },
};
</script>
<style scoped>
.smallideapost{
    position: fixed;
    bottom: 40px;
    width: calc(100% - 20px);
    z-index: 1;
}
.v-enter-active, .v-leave-active {
  transition: opacity 0.5s;
}

.v-enter{
  opacity: 0;
}
.v-enter-to{
    opacity: 1;
}
.v-leave {
    opacity: 1;
}
.v-leave-to {
    opacity: 0;
}
</style>